import styled from 'styled-components';

import { primaryText, link } from '../../../theme/typography';
import { themeColor, themeZIndex, themeShadow } from '../../../theme/getters';
import { media } from '../../../theme/media';
import { contentPadding } from '../../../theme/mixins';

import { Button as ButtonComponent } from '../button';
import { TargetLink } from '../targetLink';

export const Wrapper = styled.div`
  position: fixed;
  display: flex;
  justify-content: center;
  width: 100%;
  ${contentPadding};
  z-index: ${themeZIndex('cookiesBar')};
  left: 50%;
  transform: translateX(-50%);
  top: 16px;
  box-sizing: border-box;

  ${media.tablet`
    top: auto;
    bottom: 32px;
  `};
`;

export const Container = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: 48px;
  background-color: ${themeColor('white')};
  border: 1px solid ${themeColor('middleGray')};
  border-radius: 4px;
  border-bottom-right-radius: 6px;
  border-top-right-radius: 6px;
  ${themeShadow('primary')};
  padding: 0 102px 0 24px;
  box-sizing: border-box;

  ${media.tablet`
    max-width: 468px;
    height: 40px;
  `};
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  ${primaryText};
  font-size: 14px;
`;

export const Button = styled(ButtonComponent)`
  width: 80px;
  text-transform: none;
  font-size: 14px;
  letter-spacing: 0;
  box-shadow: none;
  position: absolute;
  top: -1px;
  right: -1px;
  height: 48px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;

  &:after {
    border: none;
  }

  ${media.tablet`
    height: 40px;
  `};
`;

export const Link = styled(TargetLink)`
  ${link};
  text-transform: none;
`;
